// src/config.js

const BASE_URL = process.env.REACT_APP_BASE_URL;
const SHARE_URL = process.env.REACT_APP_SHARE_URL;
const WEB_SOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;

//admin
const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL;
const NEWSLETTER_URL = process.env.REACT_APP_NEWSLETTER_URL;
const GET_ATTRIBUTES_BASE_URL = process.env.REACT_APP_GET_ATTRIBUTES_BASE_URL;

// Debug
const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === "true";

const config = {
  API_URL: BASE_URL,
  WEB_SOCKET_URL: WEB_SOCKET_URL,
  BACKEND_URL: BASE_URL,
  //admin
  ADMIN_BASE_URL: ADMIN_BASE_URL,
  NEWSLETTER_URL: NEWSLETTER_URL,
  GET_ATTRIBUTES_BASE_URL: GET_ATTRIBUTES_BASE_URL,

  // Debug
  DEBUG_MODE,


  // RabbitMQ Credentials
  RABBITMQ_USERNAME: process.env.REACT_APP_RABBITMQ_USERNAME,
  RABBITMQ_PASSWORD: process.env.REACT_APP_RABBITMQ_PASSWORD,

  // Share URLs
  SHARE_URLS: {
    POST: `${SHARE_URL}/post`,
    PROFILE: `${SHARE_URL}/profile`,
    WORK: `${SHARE_URL}`,
    PROJECT: `${SHARE_URL}`,
    EVENT: `${SHARE_URL}`,
    COMPETITION: `${SHARE_URL}`
  },

  // Social Media Sharing URLs (these can remain constant)
  SOCIAL_MEDIA: {
    FACEBOOK: "https://www.facebook.com/sharer/sharer.php?u=",
    TWITTER: "https://twitter.com/intent/tweet?url=",
    WHATSAPP: "https://api.whatsapp.com/send?text=",
    LINKEDIN: "https://www.linkedin.com/sharing/share-offsite/?url=",
  },
  
};

export default config;

